import { mapGetters } from 'vuex';

import errorCommentsItem from '@/components/errorComments/errorCommentsItem/index.vue';
import commentForm from '@/components/helpers/commentForm/index.vue';

import preloader from '@/components/preloader/index.vue';

import Api from '@/utils/api';

export default {
  components: {
    commentForm,
    errorCommentsItem,
    preloader,
  },
  props: {
    error: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data () {
    return {
      commentData: [],
      comment: '',
      load: false,
      loading: false,
      refreshKey: 0,
    };
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
    /**
         * Check opportunity send comment
         */
    checkComment () {
      if (Array.isArray(this.error.Commentators)) {
        if (this.error.Commentators.includes(this.user.UserId)) {
          return false;
        }
      }
      return true;
    },
  },
  created () {
    this.getComment();
  },
  methods: {

    /**
         * Work for comments
         */
    getComment () {
      this.load = true;

      Api.reports
        .getErrorsItemComment(this.error.ID)
        .then((response) => {
          if (response.data.Status) {
            this.commentData = response.data.Data;
            this.load = false;
          }
        });
    },

    /**
         * Send comment
         */
    sendComment () {
      Api.reports
        .sendErrorItemComment(this.error)
        .then((response) => {
          if (response.data.Status) {
            this.$root.$emit('notification', {
              message: 'Successful send message',
              type: 'info',
              show: true,
            });

            this.$emit('addComment');
            this.getComment();
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },

    /**
         * Remove comment
         */
    removeComment () {
      this.getComment();
      this.$emit('removeComment');
    },

    /**
         * Method for change comment
         *
         * @param {String} newComment
         */
    changeCommentInput (newComment) {
      this.error.ErrorComment = newComment;
      this.comment = newComment;
    },
  },
};
